import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18e36198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "com_side_fixed_cnt1_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "奨励・表彰制度進捗状況", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "実績詳細"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "実績詳細")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "now1" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "now1" }, "■奨励制度", -1))
const _hoisted_9 = { class: "data1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "売上増加（累計）", -1))
const _hoisted_11 = { class: "data1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "奨励金進捗（参考）", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "now1" }, "■表彰制度", -1))
const _hoisted_14 = { class: "data1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "売上（累計）", -1))
const _hoisted_16 = { class: "data1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ユニーク稼働（累計）", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "com_side_fixed_cnt1",
      class: _normalizeClass({ open: _ctx.isOpneFloating })
    }, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOpenFloating && _ctx.toggleOpenFloating(...args)))
      }, _hoisted_3),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: "button1",
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleShosaiLinkClick && _ctx.handleShosaiLinkClick(...args)), ["prevent"]))
          }, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.imageClock,
              alt: ""
            }, null, 8, _hoisted_7),
            _createTextVNode(" " + _toDisplayString("＜" + _ctx.hokokuYear + "年" + _ctx.hokokuMonth + "月末時点＞進捗状況"), 1)
          ]),
          _hoisted_8,
          _createElementVNode("dl", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("dd", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["roboto", { negative: _ctx.isNegative(_ctx.shoreiRuikeiZokagaku) }])
              }, _toDisplayString(_ctx.shoreiRuikeiZokagaku), 3),
              _createTextVNode(" 円 ")
            ])
          ]),
          _createElementVNode("dl", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("dd", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["roboto", { negative: _ctx.isNegative(_ctx.shoreiShinchokuJokyo) }])
              }, _toDisplayString(_ctx.shoreiShinchokuJokyo), 3),
              _createTextVNode(" 円 ")
            ])
          ]),
          _hoisted_13,
          _createElementVNode("dl", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("dd", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["roboto", { negative: _ctx.isNegative(_ctx.hyoshoRuikeiZokagaku) }])
              }, _toDisplayString(_ctx.hyoshoRuikeiZokagaku), 3),
              _createTextVNode(" 円 ")
            ])
          ]),
          _createElementVNode("dl", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("dd", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["roboto", { negative: _ctx.isNegative(_ctx.hyoshoRuikeiKadoId) }])
              }, _toDisplayString(_ctx.hyoshoRuikeiKadoId), 3),
              _createTextVNode(" ID ")
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}